import { required } from 'vuelidate/lib/validators'

export default {
  agenda: {
    company_address_id: {
      required
    },
    // professional_id: {
    //   required
    // },
    specialities: {
      required
    },
    name: {
      required
    },
    covenants: {
      required: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/resources/validations.js